import { mapActions } from 'vuex'

export default {
  name: 'SessionExpiredModal',
  props: {
    userSessionExpired: {
      required: true,
      type: Boolean,
    },
  },
  methods: {
    ...mapActions('users', ['clearState']),
    triggerRedirect() {
      this.clearState();

      if (this.$route.path !== '/login') {
        this.$router.push({ path: `/` })
      }
    },
  },
}
